import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  MessageButtonContent,
  MessageContent,
  MessageService,
} from '../../core/services/message.service';
import { NgClass } from '@angular/common';
import {
  MatCard,
  MatCardContent,
  MatCardActions,
} from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-message-modal',
  templateUrl: './message-modal.component.html',
  styleUrls: ['./message-modal.component.scss'],
  imports: [
    NgClass,
    MatCard,
    MatCardContent,
    MatIcon,
    MatCardActions,
    MatButton,
  ],
})
export class MessageModalComponent implements OnInit, OnDestroy {
  showModal = false;
  message: MessageContent;
  messageSubscription$: Subscription;
  messageType: 'success' | 'warning' | 'error';

  private messageService = inject(MessageService);

  ngOnInit() {
    this.messageSubscription$ = this.messageService.showModal$.subscribe(
      (data) => {
        this.showModal = true;
        this.messageType = data.type;
        this.message = data.message;
      },
    );
  }

  ngOnDestroy() {
    this.messageSubscription$.unsubscribe();
  }

  onButtonClick(button: MessageButtonContent) {
    if (button.actionFn) {
      button.actionFn();
    }
    this.showModal = false;
  }
}
